<!-- List of available categories -->
<template>
  <v-row class="fill-height ma-0" align="center" justify="start">
    <v-col cols="12">
      <v-btn @click="goToPage('Homepage')" depressed color="secondary">
        <v-icon class="secondary-font-color" left>keyboard_arrow_left</v-icon>
        <div class="secondary-font-color">{{ $translate('BACK') }}</div>
      </v-btn>
    </v-col>

    <v-col cols="12">
      <h2>{{ $translate('AVAILABLE_CATEGORIES') }}</h2>
    </v-col>

    <template v-for="(productCategory, index) in categoryList">
      <v-col :key="index" cols="12" sm="4" md="3">
        <ImageCard
          :imgSrc="productCategory.PictureUrl"
          :text="productCategory.Name"
          @click="categorySelected(productCategory)"
        />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import uiHelpers from '@/shared/ui_helpers';
import ImageCard from '@/components/generalComponents/uiComponents/ImageCard';
import Event from '@/objects/Event';

export default {
  name: 'EventDetailsProducts_Categories',
  mixins: [uiHelpers],
  components: {
    ImageCard,
  },
  props: {
    propsData: {},
    scrollToSection: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      scrollToSectionRef: this.scrollToSection,
      categoryList: [],
    };
  },
  computed: {},
  mounted() {
    this.initCategories();
  },
  updated() {
    if (this.scrollToSectionRef) {
      this.scrollToSectionRef = false;
      window.EventBus.fire('scrollToRightPosition', '#eventDetailsProducts');
    }
  },
  methods: {
    initCategories() {
      this.categoryList = this.propsData.categories;
    },
    categorySelected(category) {
      // this.$store.commit('category/setCategoryDetails', category);
      // Clearing current Details for event page first, then fill
      this.$store.commit('setCurrentDetailsForEventPage', {});
      this.$store.commit('setCurrentDetailsForEventPage', {
        Type: 'ProductCategory',
        Id: category.Id || category.CategoryId,
        Description: category.Description,
        Name: category.Name,
        Picture: category.PictureUrl,
        Video: '',
        PortraitVideo: '',
      });
      this.goToPage('ProductCategory', {
        event_id: Event.getEventId(this.$route),
        category_id: category.Id,
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
